import type { TAction } from '@hozana/redux/types'

import { IntentionActionTypes } from './constants'

export const setWidgetIntention = (
  id: number,
  hash: string,
): TAction<IntentionActionTypes.SET_WIDGET_INTENTION, { id: number; hash: string }> => ({
  type: IntentionActionTypes.SET_WIDGET_INTENTION,
  id,
  hash,
})

export const clearWidgetIntention = (): TAction<
  IntentionActionTypes.SET_WIDGET_INTENTION,
  { id: number; hash: string }
> => ({
  type: IntentionActionTypes.SET_WIDGET_INTENTION,
  id: null,
  hash: null,
})
